import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import { makeEmployeeOptions } from 'modules/core/components/Filter/filters/premade/employeeOptions'
import i18n from 'modules/core/lib/i18n'
import { type Users } from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'

const employeeFilter = (source: ReturnType<typeof useDocumentsDataTable>, users: Users) => {
  const employeeOptions = makeEmployeeOptions(employees, users)
  const options = employeeOptions.sort((a, b) => a.label.localeCompare(b.label))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'employee_id',
    path: 'employee',
    title: i18n.t('documents.employee.filters.employee'),
  })
}

export default employeeFilter
